import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import {
  RmResponsiveSelectComponent,
  SearchFilterPipe,
} from './rm-responsive-select.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RomaToolTipModule } from '@web-frontend/shared/directives/roma-tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { UserAvatarModule } from '../../user-avatar/user-avatar.module';

@NgModule({
  declarations: [RmResponsiveSelectComponent, SearchFilterPipe],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    MatProgressSpinnerModule,
    MatCheckboxModule,
    RomaToolTipModule,
    MatMenuModule,
    UserAvatarModule,
  ],
  providers: [TitleCasePipe],
  exports: [RmResponsiveSelectComponent],
})
export class RmResponsiveSelectModule {}
